module KendoWidgets
{
	export class CheckBoxClickEvent
	{
		sender: KendoWidgets.CheckBox;
		checked: boolean;
	}

	export class CheckBoxOptions
	{
		label?: string;
		checked?: boolean;
		enabled?: boolean;
		css?: string;
		width?: string | number;
		wrapper?: string | JQuery | Element;
		labelOutside?: string;

		check?(e: KendoWidgets.CheckBoxClickEvent): void;
	}

	export class CheckBox extends kendo.ui.Widget implements KendoWidget
	{
		private _state: boolean;
		private _label: KendoWidgets.Label;
		private _isEnabled: boolean;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.CheckBox; }

		constructor(element: Element, options?: KendoWidgets.CheckBoxOptions)
		{
			if (options == null)
				options = new KendoWidgets.CheckBoxOptions();

			if (options.label == null) options.label = "";
			if (options.checked == null) options.checked = false;
			if (options.enabled == null) options.enabled = true;

			(element as HTMLElement).classList.add("k-checkbox");
			$(element).attr("type", "checkbox");

			//#region Label
			let divContainer = document.createElement("span");
			$(element).wrap(divContainer);

			$("#" + element.id + "Label").remove();
			let label = document.createElement("label");
			let kendoLabel = $(label).kendoLabel(
				{
					text: options.label
				}).data("kendoLabel");

			$(label).attr("for", element.id);
			$(label).attr("id", element.id + "Label");
			label.classList.add("k-checkbox-label");
			$(element).after(label);

			$(element).parent().attr("id", element.id + "Parent");
			$(element).parent().addClass("controlParent");
			//#endregion

			//#region CSS
			if (options.css != null)
				label.style.cssText += options.css;
			//#endregion

			//#region Width
			if (options.width != null)
			{
				if (typeof (options.width) == "number")
					options.width = options.width + "px";
				(element.parentElement as HTMLElement).style.cssText += "display: inline-block; width: " + options.width;
			}
			//#endregion

			super(element, options);
			let that = this;
			that._state = false;
			that._label = kendoLabel;

			//#region Checked
			if (options.checked)
				this.checked(true);
			//#endregion

			//#region Enabled
			(element as HTMLInputElement).disabled = !options.enabled;
			this._isEnabled = options.enabled;
			//#endregion

			//#region Check
			let checkUserOverride = options.check;
			$(element).click((e: KendoWidgets.CheckBoxClickEvent) =>
			{
				that.checked((that.element[0] as HTMLInputElement).checked);

				e.sender = that;
				e.checked = that.checked();

				if (checkUserOverride != null)
					checkUserOverride(e);
			});
			//#endregion

			//#region Label outside
			if (options.labelOutside != null && options.labelOutside.length > 0)
			{
				$("#" + element.id + "labelOutside").remove();
				let label = document.createElement("label");
				label.id = element.id + "labelOutside";
				$(label).kendoLabel(
					{
						text: options.labelOutside,
						color: KendoWidgets.ColorEnum.BlueVettore,
						fontSize: 14,
						height: 19,
						width: "100%",
						css: "margin-bottom: 5px;"
					});

				$(element).parent().prepend(label);
			}
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().wrap(options!.wrapper!));
			//#endregion
		}

		clear()
		{
			this.checked(false);
		}

		checked(state?: boolean, triggerChange = false)
		{
			if (state != null)
			{
				this._state = state;
				(this.element[0] as HTMLInputElement).checked = state;

				if (triggerChange === true)
				{
					let options = this.getOptions();
					if (options.check != null)
					{
						let event = new CheckBoxClickEvent();
						event.sender = this;
						event.checked = state;
						options.check(event);
					}
				}
			}

			return this._state;
		}

		label(): KendoWidgets.Label | null
		{
			return this._label;
		}

		enabled(value?: boolean)
		{
			if (value != null)
			{
				(this.element[0] as HTMLInputElement).disabled = !value;
				this._isEnabled = value;
			}

			return this._isEnabled;
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().show();
				else
					this.element.parent().hide();
			}

			return this.element.parent().is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}
		//#endregion

		focus()
		{
			this.element.focus();
		}

		getOptions()
		{
			return this.options as KendoWidgets.CheckBoxOptions;
		}
	}

	CheckBox.fn = CheckBox.prototype;
	CheckBox.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	CheckBox.fn.options.name = "CheckBox";
	kendo.ui.plugin(CheckBox);
}

interface JQuery
{
	kendoCheckBox(options?: KendoWidgets.CheckBoxOptions): JQuery;
	data(key: "kendoCheckBox"): KendoWidgets.CheckBox;
}